import type { Metadata } from '@atlaskit/collab-provider/types';

import { cfetch } from '@confluence/network';

import { getCollabProviderUrl } from './collabProviderUrl';

export type InitialDraft = {
	document: any;
	version: number;
	metadata?: Metadata;
};

export type FetchDraft = {
	draft: InitialDraft | null;
	response?: Response;
	error?: Error;
};

export async function fetchDraft(documentAri: string, token?: string | null): Promise<FetchDraft> {
	const url = getCollabProviderUrl();
	const encodeARI = encodeURIComponent(documentAri);

	const headers: HeadersInit = {
		'Content-Type': 'application/json',
		'Cache-Control': 'no-cache',
	};

	if (token) {
		headers['X-Token'] = token;
	}

	const response = await cfetch(`${url}/document/${encodeARI}/draft?format=pm`, {
		method: 'GET',
		headers: { ...headers },
	});

	if (response.ok) {
		// draftResponse from endpoint will contain a document (ProseMirrorNode JSON string),
		// metadata, and version number

		// On the client side, document will then be converted into a JSON object
		const responseJson = await response.json();
		const draft = {
			...responseJson,
			document: JSON.parse(responseJson.document),
		};

		return { draft, response };
	}

	return { draft: null, response };
}
